import styled from 'styled-components'
import { FaTree } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import {Container} from '../../styles/globalStyles'

export const Nav = styled.nav`
background-color: white;
box-shadow: 20px 20px 40px white;
  height: 90px;
 display: flex;
 justify-content: center;
 align-items: center;
 /* font-size: 1.2rem; */
 position: sticky;
 top: 0;
 z-index: 5;

@media screen and (max-width:1170px) {
  transition:0.8s all ease;
}
`;

export const NavbarContainer = styled(Container)`
display: flex;
justify-content: space-between;
height: 5;
background-color: white;
/* box-shadow: 12px 10px 10px rgba(37, 34, 34, 0.733); */
${Container}
`;

export const Logo = styled(Link)`
font-family: 'Aref Ruqaa', 'Rubik';
  color: #1A4301;
  justify-self: flex-start;
  cursor: pointer;
  text-decoration: none;
  font-size: 2.8rem;
  display: flex;
  align-items: center;
  @media screen and (max-width: 310px) {
    font-size: 1rem;
    
  }
  @media screen and (max-width: 500px) {
    font-size: 1.6rem;

  }
`;

export const Icon = styled(FaTree)`
  margin-right: 5px;
  font-size: 30px;
`;

export const Burger = styled.div`
  display: none;
  
  @media screen and (max-width: 1170px) {
    color: #538D22;
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(-100%, 60%);
    font-size: 1.8rem;
    cursor: pointer;
  }
`;

export const Menu = styled.ul`
  display: flex;
  align-items: center;
  list-style: none;
  text-align: center;

  @media screen and (max-width: 1170px) {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 95vh;
    position: absolute;
    top: 80px;
    left: ${({ click }) => (click ? 0 : '-100%')};
    opacity: 1;
    transition: all 0.5s ease;
    background: white;
  }
`;

export const Item = styled.li`
  height: 80px;
  border-bottom: 3px solid transparent;
 

  &:hover {
      border-bottom: 2px solid #538D22; 
  }

  @media screen and (max-width: 1170px) {
    width: 100%;

    &:hover {
      border: none;
    }
  }
`;

export const ItemBtn = styled.li`
  @media screen and (max-width: 1170px) {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 120px;
  }
`;

export const NavLinks = styled(Link)`
 font-family: 'Cairo',  sans-serif;
  color: #538D22;
  display: flex;
  font-size: 18px;
  font-weight:bold;
  text-shadow : 1px 1px #1A4301;
  align-items: center;
  text-decoration: none;
  padding: 0.5rem 1rem;
  height: 100%;

  @media screen and (max-width: 1170px) {
    text-align: center;
    padding: 2rem;
    font-size: 1.4rem;
    width: 100%;
    display: table;

    &:hover {
      color: #b6fa7f;
      text-shadow : 2px 2px #538D22;
      transition: all 0.5s ease;
    }
  }
`;

export const BtnLink = styled(Link)`
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  padding: 5px 12px;
  height: 100%;
  width: 100%;
  border: none;
  outline: none;
`;

export const BtnLogout = styled.button`
  border-radius: 50px;
  border : 2px solid black;
  background-color: white;
  color: #bb3333;
  text-shadow : 1px 1px #bb3333;
  font-family: 'Cairo', sans-serif;
  white-space: nowrap;
  padding: 8px 16px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 18px;
  

  transition-duration: 0.4s;
  cursor: pointer;

  &:hover {
    transition: all 0.3s ease-out;
    color: white;
    background-color: #bb3333;
  }

  @media screen and (max-width: 1170px) {
    width: 100%;
  }
`;

export const NavButton = styled.button`
  border-radius: 50px;
  border : 2px solid #1A4301;
  background-color: white;
  color: #1A4301;
  text-shadow : 1px 1px #538D22;
  font-family: 'Cairo','Rubik', sans-serif;
  white-space: nowrap;
  padding: 8px 16px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 18px;
 

  transition-duration: 0.4s;
  cursor: pointer;

  &:hover {
    transition: all 0.3s ease-out;
    color: white;
    background-color: #538D22;
  }

  @media screen and (max-width: 1170px) {
    width: 100%;
  }
`;
